import { Building, Building2, Home, Activity } from "lucide-react";

const WhoWeServeSection = () => {
  const facilities = [
    { 
      icon: Building2, 
      title: "LTACH", 
      subtitle: "Long-Term Acute Care Hospitals",
      description: "Specialized documentation for extended care facilities"
    },
    { 
      icon: Building, 
      title: "STACH", 
      subtitle: "Short-Term Acute Care Hospitals",
      description: "Efficient documentation for rapid patient turnover"
    },
    { 
      icon: Home, 
      title: "SNF", 
      subtitle: "Skilled Nursing Facilities",
      description: "Comprehensive notes for ongoing patient care"
    },
    { 
      icon: Activity, 
      title: "Acute Care", 
      subtitle: "Acute Care Facilities",
      description: "Real-time documentation for critical care settings"
    },
  ];

  return (
    <section 
      id="about"
      data-testid="who-we-serve-section"
      className="py-16 sm:py-24 md:py-32 bg-[#0A0A0A]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-16">
          <span className="text-xs sm:text-sm font-medium uppercase tracking-widest text-cyan-500 mb-3 sm:mb-4 block">
            Our Focus
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-white mb-3 sm:mb-4">
            Who We Serve
          </h2>
          <p className="text-base sm:text-lg text-slate-400 max-w-2xl mx-auto px-4">
            Where We Focus — Healthcare facilities that demand excellence in documentation
          </p>
        </div>

        {/* Facility Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {facilities.map((facility, index) => (
            <div 
              key={index}
              className="glass-card p-4 sm:p-6 md:p-8 text-center card-hover-lift group"
            >
              <div className="w-12 h-12 sm:w-16 sm:h-16 mx-auto mb-4 sm:mb-6 rounded-xl sm:rounded-2xl bg-cyan-500/10 border border-cyan-500/20 flex items-center justify-center group-hover:bg-cyan-500/20 transition-colors">
                <facility.icon className="w-6 h-6 sm:w-8 sm:h-8 text-cyan-400" />
              </div>
              <h3 className="text-lg sm:text-2xl font-bold text-white mb-1 sm:mb-2">{facility.title}</h3>
              <p className="text-cyan-400 text-xs sm:text-sm font-medium mb-2 sm:mb-3 leading-tight">{facility.subtitle}</p>
              <p className="text-slate-400 text-xs sm:text-sm hidden sm:block">{facility.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoWeServeSection;
